import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'otto-olsen-load-order-to-cart-modal',
    templateUrl: './otto-olsen-load-order-to-cart-modal.component.html',
    styleUrl: './otto-olsen-load-order-to-cart-modal.component.scss',
    standalone: false
})
export class OttoOlsenLoadOrderToCartModalComponent {
  constructor(public activeModal: NgbActiveModal) {}
}
